import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/tools/infinitetalk-demo")({
  component: () => <Navigate to="/tools/ai-avatar" />,
})
